
import { Component, Vue } from 'nuxt-property-decorator'
import IconAlaoSmile from '~/assets/icons/alao-smile.svg?inline'

@Component({
  components: {
    IconAlaoSmile,
  },
})
export default class OfferCardExclusiveLabel extends Vue {
}
